import { FontAlignmentEnum } from '../../../Common/Forms/enums/font-alignment.enum';

export class TextStyleDefaultsModel {
    fontSize: string;
    fontColor: string;
    bold: boolean;
    underline: boolean;
    alignment: FontAlignmentEnum;

    constructor(
        fontSize: string,
        fontColor: string,
        bold: boolean,
        underline: boolean = false,
        alignment: FontAlignmentEnum = null
    ) {
        this.fontSize = fontSize;
        this.fontColor = fontColor;
        this.bold = bold;
        this.underline = underline;
        this.alignment = alignment;
    }
}
